import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';

export const BoxWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '16px'
}));

export const IconButtonWrapper = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  marginBottom: '16px',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#273e9e'
  }
}));
